<template>
  <div :class="!classPrefix ? 'form__group' : `${classPrefix}__group`" :style="`--width: ${width || '100%'}`">
    <label :class="!classPrefix ? 'form__label' : `${classPrefix}__label`">
      {{ label }}:
      <font-awesome-icon :icon="['fas', 'circle-exclamation']" v-if="required" />
    </label>

    <input ref="fileInput" type="file" @change="handleUpload" style="display: none;" :accept="accept ? accept : ''" />

    <div class="form__file">
      <input type="text" :value="fileName" disabled class="form__input" style="flex: 3;"/>

      <button type="button" @click="triggerUpload" class="form__input" style="margin-left: 8px; flex: 1; cursor: pointer" >
        Escolher Arquivo
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormInput',
  props: {
    label: {
      type: String,
      required: true
    },
    width: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: true
    },
    accept: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    },
    modelValue: {
      type: [Number, String],
      required: false
    },
    idx: {
      type: String,
      required: false
    },
    classPrefix: {
      type: String,
      required: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      fileName: '',
    };
  },
  methods: {
    updateValue(event) {
      this.$emit('update:modelValue', event.target.value);
    },
    triggerUpload() {
      this.$refs.fileInput.click();
    },
    handleUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.fileName = file.name;
        this.$emit('update:fileContent', file);
      }
    }
  }
}
</script>
